document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
        increasePostViews();
    }, 5000);
});

async function increasePostViews() {
    try {
        const postId = getPostId();
        const ajaxUrl = getMetaContent('ajax-url');

        if (!postId || !ajaxUrl) {
            return;
        }

        const formData = new FormData();
        formData.append('single_post_id', postId);
        formData.append('action', 'increase_post_views');

        const response = await fetch(ajaxUrl, {
            method: 'POST',
            body: formData,
        });


        const data = await response.text();
    } catch (error) {
        console.error('Chyba při zvyšování počtu zobrazení příspěvku:', error);
    }
}

const getPostId = () => {
    return getMetaContent('post_id');
}

const getMetaContent = (name) => {
    const meta = document.head.querySelector(`meta[name="${name}"]`);
    return meta ? meta.content : null;
}
